import { TextLink } from '@/components/TextLink';
import { typeGuardInvoiceReportMfFile } from '@/context/services/reportsType/invoiceReports/type-guard';
import {
  ApprovingInvoiceReportFormInputResponse,
  ApprovingInvoiceReportFormInputResponseInputAdditionalValuesItem,
  InvoiceReportMfFile,
} from 'ap-openapi';
import { FC, memo, useMemo } from 'react';

type FileFieldViewProps = {
  item: ApprovingInvoiceReportFormInputResponse;
};

export const FileFieldView: FC<FileFieldViewProps> = memo(({ item }) => {
  const baseURL = location.origin;
  const fileDataArray = useMemo(() => {
    if (Array.isArray(item?.input_additional_values)) {
      return item?.input_additional_values?.filter(
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        typeGuardInvoiceReportMfFile as (
          value: ApprovingInvoiceReportFormInputResponseInputAdditionalValuesItem
        ) => value is InvoiceReportMfFile
      );
    }

    if (
      item?.input_additional_values &&
      typeGuardInvoiceReportMfFile(item?.input_additional_values)
    ) {
      return [item?.input_additional_values];
    }

    return [];
  }, [item?.input_additional_values]);

  if (fileDataArray.length === 0) {
    return null;
  }

  return (
    <>
      {fileDataArray.map((fileData: InvoiceReportMfFile) => (
        <TextLink
          containerMaxWidth='unset'
          href={`${baseURL}/mf_files/${fileData?.id}`}
          key={fileData?.id ?? 'empty-view-file-field'}
          fileName={fileData?.name ?? ''}
        />
      ))}
    </>
  );
});

FileFieldView.displayName = 'FileFieldView';
